import styled from 'styled-components';

import Box from '../../../../_shared/components/Box';
import Label from '../../../../_shared/components/Label';
import { Column } from '../Styles';

export const StyledBody = styled(Box.Column)`
  flex: 1 1 auto;
`;

export const Header = styled(Box)`
  align-items: flex-start;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledDistanceWrapper = styled(Box)`
  flex: 1 1 auto;
`;

export const StyledTradeName = styled(Label.Bold)`
  margin-top: 3px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
`;

export const StyledTitle = styled(Box)`
  padding-top: 6px;
  padding-right: 6px;
  max-width: inherit;
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  background: ${({ theme }) => theme.COLORS.TRANSPARENT};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export const ContentContainer = styled(Column)`
  padding: 0px 0px 13px;
  margin-left: 16px;
`;
